import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';

import CBInput from './CBInput';

import { useState, useEffect } from 'react';

import NavAndSearch from "../NavAndSearch"
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function CBRatio() {

  const [inputs, setInputs] = useState(['input0','input1', 'input2'])
  const [inputCount, setInputCount] = useState(3)

  // main purpose is to trigger useEffect in this component, changes in the CBInputs will trigger this state then trigger useEffect
  const [salesArray, setSalesArray] = useState([])
  const [cbsArray, setCbsArray] = useState([])

  const [totalSales, setTotalSales] = useState(0)
  const [totalCBs, setTotalCBs] = useState(0)

  function createInput() {
    setInputCount(inputCount + 1)
    setInputs([...inputs, `input${inputCount}`])
  }

  function formatNumber(number) {
    return number.toLocaleString(undefined, { maximumFractionDigits: 2 })
  }

  // 
  useEffect(() => {
    const salesvalues =[]
    const cbvalues =[]
    // Find all elements by className in React
    // https://bobbyhadz.com/blog/react-find-all-elements-with-class
    const salesClass = Array.from(document.querySelectorAll('.sales'))
    const cbsClass = Array.from(document.querySelectorAll('.chargebacks'))
    // Converting strings to numbers with vanilla JavaScript 
    // https://gomakethings.com/converting-strings-to-numbers-with-vanilla-javascript/
    salesClass.map((i) => i.value && salesvalues.push(Number(i.value)))
    cbsClass.map((i) => i.value && cbvalues.push(Number(i.value)))
    // Fastest JavaScript summation
    // https://stackoverflow.com/questions/3762589/fastest-javascript-summation
    const sumOfSales = salesvalues.reduce((pv, cv) => pv + cv, 0)
    const sumOfCBs = cbvalues.reduce((pv, cv) => pv + cv, 0)
    setTotalSales(sumOfSales)
    setTotalCBs(sumOfCBs)
  }, [salesArray, cbsArray])

  function cbColorHighlight(ratio) {
    if (ratio >= 2) {
      return 'cbColorHighlightRed'
    } else if (ratio >= 1.5) {
      return 'cbColorHighlightAmber'
    } else if (ratio < 1.5) {
      return 'cbColorHighlightGreen'
    }
  }

  return (
    <>
    <NavAndSearch />
    <Container fluid='xxl' className='boostrapContainer mb-3 pb-3 rounded' style={{ marginTop: '4.5rem' }}>
      <Row>
        <Col>
          <h5>🧮 Chargeback Ratio Calculator</h5>
          <hr style={{margin: '0 0 1rem 0'}}/>
        </Col>
      </Row>
      <Row>
        <Col className='calcCol calcHeader colGroup p-3 m-2 rounded'>
          <span>Months</span>
          <span>{inputCount}</span>
        </Col>
        <Col xs={3} className='calcCol calcHeader colGroup p-3 m-2 rounded'>
          <span>Notes / ISO / MID</span>
        </Col>
        <Col className='calcCol calcHeader colGroup p-3 m-2 rounded'>
          <span>Sales</span>
          <span>{formatNumber(totalSales)}</span>
        </Col>
        <Col className='calcCol calcHeader colGroup p-3 m-2 rounded'>
          <span>Chargebacks</span>
          <span>{formatNumber(totalCBs)}</span>
        </Col>
        <Col xs={2} className={`calcCol calcHeader colGroup p-3 m-2 rounded ${cbColorHighlight((totalCBs/totalSales)*100)}`}>
          <span>CB Ratio %</span>
          <span>{totalCBs && totalSales && ((totalCBs/totalSales)*100).toFixed(2)}</span>
        </Col>
      </Row>

      {
        inputs.map((item, index) => (
          <CBInput
            key={item}
            inputNumber={index+1}
            item={item}
            salesArray={salesArray}
            setSalesArray={setSalesArray}
            cbsArray={cbsArray}
            setCbsArray={setCbsArray}
            formatNumber={formatNumber}
            cbColorHighlight={cbColorHighlight}
          />))
      }

      <Row>
        <Col className='calcCol colGroup p-1 m-2 rounded'>
          <button className='addRowButton' onClick={() => createInput()}>+</button>
        </Col>
      </Row>
    </Container>
    </>
  )
}

export default CBRatio